export var toInteger = value => parseInt(value, 10);
export var toIntegerOrNull = value => typeof value === 'number' ? value : value != null && toInteger(value) || null;